module.exports = __webpack_public_path__ + "static/media/Renovation-Societe-Vaud.56028ee1.jpg";